export enum FinanceType {
  CASH = `cash`,
  CONCERT = `concert`,
  LIGHT_REACH = `lightreach`,
  GOODLEAP = `goodleap`,
  ENFIN = `enfin`,
  SUNGAGE = `sungage`,
  CREDIT_HUMAN = `credit_human`,
}

export const LIGHT_REACH_BATTERY_FINANCE_TYPE = `lightreach_battery`

export const POWUR_CARE_WARRANTY_FAMILY = `powur_care`

export const isTpoFinanceSelection = ({
  financeType,
  loanType,
}: {
  financeType?: string | null
  loanType?: string | null
}): boolean =>
  financeType === FinanceType.LIGHT_REACH ||
  financeType === LIGHT_REACH_BATTERY_FINANCE_TYPE ||
  loanType === `ppa`

export enum FundingGroup {
  LightReachPPA = `LightReach Predictable PPA`,
  LightReachLease = `LightReach Solar Lease`,
  GoodleapTpo = `Goodleap - TPO`,
  GoodleapLease = `Goodleap - Loan`,
  EnfinTpo = `Enfin - TPO`,
  SungageBrightStar = `Sungage - BrightStar`,
  SungageSunriseEscalator = `Sungage - Sunrise Escalator`,
  SungageBatteryBrightStart = `Sungage - BrightStart (Battery Only)`,
  SungageBatterySunrise = `Sungage - Sunrise (Battery Only)`,
  CreditHuman = `Credit Human`,
}
